export default "__VITE_ASSET__470cf022__"